import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UploadFileComponent} from './upload-file.component';
import {DndDirective} from './dnd.directive';
import {UploadFileLogoComponent} from './upload-file-logo/upload-file-logo.component';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [UploadFileComponent, UploadFileLogoComponent, DndDirective],
  exports: [UploadFileComponent, UploadFileLogoComponent],
  imports: [CommonModule, TranslateModule],
})
export class UploadFileModule {
}
